import { createPinia } from "pinia";
const stores = createPinia();
export default stores;